import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade, Carousel } from 'react-bootstrap';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { AutoAffix } from 'react-overlays';

import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

import PanelContent from './PanelContent';
import PanelBlurb from './PanelBlurb';

import StarsContent from './StarsContent';
import StarsBlurb from './StarsBlurb';

import TinyEngineContent from './TinyEngineContent';
import TinyEngineBlurb from './TinyEngineBlurb';

import NodeContent from './NodeContent';
import NodeBlurb from './NodeBlurb';

import SpoiledTomatillosContent from './SpoiledTomatillosContent';
import SpoiledTomatillosBlurb from './SpoiledTomatillosBlurb';

import './MobileProjects.css'

export default class MobileProjects extends Component {
  render() {
    return (
      <div>

        <div className='myBox'>
              <Thumbnail className="my-thumbnail" src="assets/tts/title.png" alt="242x200">

                <h3>Through the Stars</h3>

                <div className='mobile-btn-group'>
                  <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                  <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>
                </div>

                <StarsContent/>

                  <div className="mobile-content">
                    <Image src="assets/tts/screenshot-1.png" className="mobile-screenshot" rounded/>
                    <Image src="assets/tts/screenshot-2.png" className="mobile-screenshot" rounded/>
                    <Image src="assets/tts/screenshot-3.png" className="mobile-screenshot" rounded/>
                    <Image src="assets/tts/screenshot-4.png" className="mobile-screenshot" rounded/>
                  </div>

                  <div className='video-container'>
                    <YouTube
                      className="yt-video"
                      videoId="G8gfMIPzoUM"
                    />
                  </div>

                  <div className='mobile-btn-group'>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/Through-The-Stars">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://chrisdinome.itch.io/through-the-stars">Download</AwesomeButton>
                  </div>
              </Thumbnail>
        </div>

        <div className='myBox'>
              <Thumbnail className="my-thumbnail" src="assets/tomatillos/screenshot-1.jpg" alt="242x200">

                <h3>SpoiledTomatillos</h3>

                <SpoiledTomatillosContent/>

                  <div className="mobile-content">
                    <Image src="assets/tomatillos/screenshot-3.png" className="mobile-screenshot" rounded/>
                    <Image src="assets/tomatillos/screenshot-2.png" className="mobile-screenshot" rounded/>
                  </div>

                  <div className='video-container'>
                    <YouTube
                      classNa me="yt-video"
                      videoId="tZWS0Us9t3c"
                    />
                  </div>

              </Thumbnail>
        </div>

        <div className='myBox'>
              <Thumbnail className="my-thumbnail" src="assets/tinyengine/title.png" alt="242x200">

                <h3>TinyEngine</h3>

                <div className='mobile-btn-group'>
                  <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                  <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>
                </div>

                <TinyEngineContent/>

                  <div className="mobile-content">
                    <Image src="assets/tinyengine/spaceinvaders.png" className="mobile-screenshot" rounded/>
                  </div>

                  <div className='video-container'>
                    <YouTube
                      className="yt-video"
                      videoId="TnI-HnQDgd8"
                    />
                  </div>

                  <div className='mobile-btn-group'>
                    <AwesomeButtonSocial type="github" href="https://github.com/GCSChris/TinyEngine">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://tinyenginecs4850.wordpress.com/">Website</AwesomeButton>
                  </div>

              </Thumbnail>
        </div>

        <div className='myBox'>
              <Thumbnail className="my-thumbnail" src="assets/tinyengine/title.png" alt="242x200">

                <h3>Node</h3>

                <div className='mobile-btn-group'>
                  <AwesomeButtonSocial type="github" href="https://github.com/Zilby/SoundLemmings">Source</AwesomeButtonSocial>
                  <AwesomeButton href="https://globalgamejam.org/2017/games/node">GGJ Website</AwesomeButton>
                </div>

                <NodeContent/>

                  <div className="mobile-content">
                    <Image src="assets/node/screenshot-2.png" className="mobile-screenshot" rounded/>
                  </div>

                  <div className='video-container'>
                    <YouTube
                      className="yt-video"
                      videoId="nIYjzsYEZ3E"
                    />
                  </div>

                  <div className='mobile-btn-group'>
                    <AwesomeButtonSocial type="github" href="https://github.com/Zilby/SoundLemmings">Source</AwesomeButtonSocial>
                    <AwesomeButton href="https://globalgamejam.org/2017/games/node">GGJ Website</AwesomeButton>
                  </div>

              </Thumbnail>
        </div>

    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileProjects.jsx